import React from "react";
import PropTypes from "prop-types";
import Accordion from "../../../../../components/atoms/Accordion";

const Summary = ({ item }) => {
  if (item && Object.keys(item || {}).length && item.summary) {
    const content = <div>{item.summary}</div>;
    const title = "Evidence submitted by expert";
    return (
      <div className="varsome-inner-container">
        <Accordion content={content} title={title} />
      </div>
    );
  }
  return null;
};

Summary.propTypes = {
  item: PropTypes.shape({
    approval_date: PropTypes.string,
    disease: PropTypes.string,
    evidence_met: PropTypes.arrayOf(PropTypes.string),
    evidence_not_met: PropTypes.arrayOf(PropTypes.string),
    expert_panel: PropTypes.string,
    guideline: PropTypes.string,
    mode_of_inheritance: PropTypes.string,
    mondo_id: PropTypes.string,
    pathogenicity: PropTypes.string,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    published_date: PropTypes.string,
    repo_link: PropTypes.string,
    retracted: PropTypes.string,
    summary: PropTypes.string,
    version: PropTypes.string,
  }),
};

Summary.defaultProps = {
  item: {},
};

export default Summary;
